


























import axios from "axios";
import { Vue, Inject, Prop } from "vue-property-decorator";
import Component from "vue-class-component";
import { Validator } from "vee-validate";

@Component({
  props: [
    "cols",
    "name",
    "value",
    "label",
    "type",
    "min",
    "max",
    "hlaType",
    "tabIndex",
    "disabled",
    "mask",
    "isValid",
    "isDonor"
  ]
})
export default class HlaInput extends Vue {
  @Inject()
  parentValidator: any;
  
  @Prop()
  name: any;
  
  @Prop()
  mask: any;  
  
  @Prop()
  validate: any;
  
  @Prop()
  isValid: any;


  protected created() {
    this.$validator = this.parentValidator;     
  }

  hasError() {
    return this.$validator.errors.has(this.name) || !this.isValid;
  }

  errorMessage() {
    if(!this.isValid)
    {
      return this.$t('Значение не может быть пустым, при не пустом значении другой аллели')
    }
    return this.$validator.errors.first(this.name);
  }

  hasValidation() {
    return this.validate;
  }

  errorState(name: any) {
    return this.$validator.errors.has(name) ? false : null;
  }  
}
